import { Injectable } from '@angular/core';
import { INewCustomCategoryFund } from '@bp-core/src/lib/models/portal/goal/new-custom-category-fund.model';
import { BehaviorSubject } from 'rxjs';
import { GoalFundingService } from './goal-funding.service';

@Injectable({
  providedIn: 'root',
})
export class CategoryCustomFundsService {
  private _currentCategoryFundAddedSubject = new BehaviorSubject<
    INewCustomCategoryFund | undefined
  >(undefined);
  currentCategoryFundAdded$ = this._currentCategoryFundAddedSubject.asObservable();

  private _currentCategoryFundRemovedSubject = new BehaviorSubject<
    INewCustomCategoryFund | undefined
  >(undefined);
  currentCategoryFundRemoved$ = this._currentCategoryFundRemovedSubject.asObservable();

  private _categoriesCustomFundsAddedSubject = new BehaviorSubject<INewCustomCategoryFund[]>([]);
  categoriesCustomFundsAdded$ = this._categoriesCustomFundsAddedSubject.asObservable();

  private _currentCategoryCustomFundsSubject = new BehaviorSubject<INewCustomCategoryFund[]>([]);
  currentCategoryCustomFunds$ = this._currentCategoryCustomFundsSubject.asObservable();

  constructor(private fundingService: GoalFundingService) {}

  setCurrentCategoryCustomFunds(customCategoryFunds: INewCustomCategoryFund[]) {
    this._currentCategoryCustomFundsSubject.next(customCategoryFunds);
  }

  addCurrentCategoryFund(customCategoryFund: INewCustomCategoryFund) {
    this._currentCategoryFundAddedSubject.next(customCategoryFund);
    this._currentCategoryFundRemovedSubject.next(undefined);
    setTimeout(() => {
      this.updateCategoriesCustomFundsAdded(customCategoryFund, true);
    }, 150);
  }

  removeCurrentCategoryFund(customCategoryFund: INewCustomCategoryFund) {
    this._currentCategoryFundRemovedSubject.next(customCategoryFund);

    this._currentCategoryFundAddedSubject.next(undefined);

    setTimeout(() => {
      this.updateCategoriesCustomFundsAdded(customCategoryFund, false);
    }, 150);
  }
  resetCurrentAddedRemoved() {
    this._currentCategoryFundAddedSubject.next(undefined);
    this._currentCategoryFundRemovedSubject.next(undefined);
  }

  resetService() {
    this._categoriesCustomFundsAddedSubject.next([]);
    this._currentCategoryCustomFundsSubject.next([]);
    this._currentCategoryFundAddedSubject.next(undefined);
    this._currentCategoryFundRemovedSubject.next(undefined);
  }

  private updateCategoriesCustomFundsAdded(
    customCategoryFund: INewCustomCategoryFund,
    isAdded: boolean,
  ) {
    let currentCategoriesCustomFunds = [...this._currentCategoryCustomFundsSubject.value];

    let categoriesCustomFundsAdded = [...this._categoriesCustomFundsAddedSubject.value];
    if (categoriesCustomFundsAdded.length === 0) {
      categoriesCustomFundsAdded.push(customCategoryFund);
      currentCategoriesCustomFunds = this.getNewCustomCategoryFund(
        customCategoryFund,
        isAdded,
        currentCategoriesCustomFunds,
      );
      this._currentCategoryCustomFundsSubject.next(currentCategoriesCustomFunds);

      // currentCategoriesCustomFunds.push(customCategoryFund);
      // this._currentCategoryCustomFundsSubject.next(currentCategoriesCustomFunds);
      this._categoriesCustomFundsAddedSubject.next(categoriesCustomFundsAdded);
      return;
    }
    categoriesCustomFundsAdded = this.getNewCustomCategoryFund(
      customCategoryFund,
      isAdded,
      categoriesCustomFundsAdded,
    );
    currentCategoriesCustomFunds = this.getNewCustomCategoryFund(
      customCategoryFund,
      isAdded,
      currentCategoriesCustomFunds,
    );
    this._currentCategoryCustomFundsSubject.next(currentCategoriesCustomFunds);

    this._categoriesCustomFundsAddedSubject.next(categoriesCustomFundsAdded);
  }

  private getNewCustomCategoryFund(
    customCategoryFund: INewCustomCategoryFund,
    isAdded: boolean,
    categoriesCustomFundsAdded: INewCustomCategoryFund[],
  ) {
    let categoriesCustomFundsAddedTemp = [...categoriesCustomFundsAdded];
    let customCategoryFundTemp = { ...customCategoryFund };
    if (isAdded) {
      const categoryAdded = categoriesCustomFundsAddedTemp.find(
        value => value.category.categoryId === customCategoryFundTemp.category.categoryId,
      );
      categoriesCustomFundsAddedTemp = this.fundingService.getNewSubCategoryFundsWithCustomFunds({
        old: categoriesCustomFundsAddedTemp,
        new: customCategoryFundTemp,
      });
    } else {
      categoriesCustomFundsAddedTemp = categoriesCustomFundsAddedTemp
        .filter(value => {
          const funds = value.customFunds.filter(
            f => f.fund.fund?.id !== customCategoryFundTemp.customFunds[0].fund?.fund?.id,
          );
          return funds.length > 0;
        })
        .map(value => {
          return {
            category: value.category,
            customFunds: value.customFunds.filter(
              f => f.fund.fund?.id !== customCategoryFundTemp.customFunds[0].fund?.fund?.id,
            ),
          };
        });
    }
    return categoriesCustomFundsAddedTemp;
  }
}
